import Span from 'components/atoms/Span';
import styled from 'styled-components';

const CardText = styled(Span)`
  color: ${props => props.theme.card.text};
  margin: 2px 0;
`;

export default CardText;
